// Include jQuery plugins
//require('jquery.sample');

// Import non-jQuery modules
//const sample = require('sample');

// Define wp_localize_script handles
/* */

(function($) {
    const wntrTheme = {
        body: $('body'),
        html: $('html'),
        document: $(document),

        /**
         * Initialise theme JS on page load
         */
        init: function() {
            // Do we have JS?
            $('html').removeClass('no-js');

            // Automatically call all methods that start with __, in the order they're defined
            for(const prop in wntrTheme) {
                if(prop.startsWith('__') && typeof wntrTheme[prop] === 'function') {
                    wntrTheme[prop].call();
                }
            }
        },

        __clickEventHandlers() {
            wntrTheme.body.find('.header__toggle').on('click', function() {
                $(this).toggleClass('is-active');
                wntrTheme.body.find('.header__mobile-menu').toggleClass('is-active');
                wntrTheme.body.toggleClass('menu-active');
            });
        },

        __slick() {
            const gallery = wntrTheme.body.find('.gallery__images');
            const imageBanner = wntrTheme.body.find('.image-banner__gallery');

            if(imageBanner.length) {
                imageBanner.slick({
                    dots: false,
                    infinite: true,
                    arrows: true,
                    pauseOnFocus: false,
                    pauseOnHover: false,
                    speed: 300,
                    swipeToSlide: true,
                    lazyLoad: 'progressive',
                    slidesToShow: 1,
                    autoplay: true,
                    autoplaySpeed: 4000,
                    prevArrow: '<button class="slick-prev slick-arrow slick-disabled" aria-label="Previous" type="button" aria-disabled="true" style=""><svg width="20" height="20" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><g><path d="M7 1L2 6L7 11" stroke="#241F1F" stroke-width="2" stroke-linecap="round"/></g></svg></button>',
                    nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="" aria-disabled="false"><svg width="20" height="20" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 11L6 6L1 1" stroke="#241F1F" stroke-width="2" stroke-linecap="round"/></svg></button>',
                    responsive: [
                        {
                            breakpoint: 1024,
                            settings: {
                                arrows: false,
                            }
                        },
                    ]
                });
            }

            if(gallery.length) {
                gallery.slick({
                    dots: false,
                    infinite: true,
                    arrows: true,
                    speed: 400,
                    swipeToSlide: true,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    centerMode: true,
                    prevArrow: '<button class="slick-prev slick-arrow slick-disabled" aria-label="Previous" type="button" aria-disabled="true" style=""><svg width="20" height="20" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><g><path d="M7 1L2 6L7 11" stroke="#241F1F" stroke-width="2" stroke-linecap="round"/></g></svg></button>',
                    nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="" aria-disabled="false"><svg width="20" height="20" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 11L6 6L1 1" stroke="#241F1F" stroke-width="2" stroke-linecap="round"/></svg></button>',
                    responsive: [
                        {
                            breakpoint: 720,
                            settings: {
                                arrows: false,
                                slidesToShow: 1,
                            }
                        },
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 1,
                            }
                        },
                    ]
                });
            }
        },

        //__onScroll() {
        //    // Simple scroll throttle
        //    $(window).on('scroll', function() {
        //        if($(window).scrollTop() <= 0 && wntrTheme.body.hasClass('started-scroll')) {
        //            wntrTheme.body.removeClass('started-scroll');
        //        } else if($(window).scrollTop() >= 60 && !wntrTheme.body.hasClass('started-scroll')) {
        //            wntrTheme.body.addClass('started-scroll');
        //        }
        //    });
        //},

        __smoothScrollToSection() {
            $(document).on('click', 'a[href^="#"]', function(e) {
                e.preventDefault();
                if($(window).innerWidth() < 720) {
                    wntrTheme.body.find('.header__mobile-menu, .header__toggle').removeClass('is-active');
                    wntrTheme.body.removeClass('is-fixed');
                }

                $('html, body').animate({
                    scrollTop: $($.attr(this, 'href')).offset().top
                }, 500);
            });
        }
    };

    $(document).ready(wntrTheme.init);
})(jQuery);